import { QueryClient } from '@tanstack/react-query';

// Admin-local QueryClient factory. We can't import this from
// `@shared/api/query-client` because that file returns a QueryClient whose
// type identity is bound to ecregi-web's @tanstack install — a different
// package instance from admin's, which TypeScript flags as incompatible.
// The factory body is trivially small; local duplication is cheaper than
// sharing across installs.
export function createQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: { retry: 1, refetchOnWindowFocus: false, staleTime: 30_000 },
      mutations: { retry: 0 },
    },
  });
}
